import sidebarConfig from '@/data/student-sidebar.json'

type Visibility = 'hidden' | 'dev' | 'prod'

const DEV_HOSTNAMES = ['localhost', '127.0.0.1']

function currentEnv(): 'dev' | 'prod' {
  if (import.meta.env.DEV) return 'dev'
  if (DEV_HOSTNAMES.includes(window.location.hostname)) return 'dev'
  return 'prod'
}

const visibilityMap = new Map<string, Visibility>(
  sidebarConfig.sections.flatMap(s =>
    s.items.map(item => [item.id, item.visibility as Visibility])
  )
)

export function isNavItemVisible(id: string): boolean {
  const v = visibilityMap.get(id)
  if (!v || v === 'hidden') return false
  if (v === 'prod') return true
  return currentEnv() === 'dev'
}
